/*  MUI  */
import { Box, Typography } from '@mui/material';

/*  Shared  */
import { QBRFIRSTREPORTS } from 'application/Shared/Constants';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { QBRScoreChip } from './QBRScoreChip';

export const QBRReportHeader = (props) => {
    const { t } = useTranslation();
    const { reportType, scoreMap } = props;
    const reportName = t(QBRFIRSTREPORTS[reportType].name);
    const reportKey = `qbrQBRFirst${reportType}`;

    return (
        <Box data-trackid="qbrRenderReportHeader">
            <Box
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <Typography variant="h1">{reportName}</Typography>
                <QBRScoreChip
                    score={scoreMap[reportKey]}
                    renderType="standalone"
                />
            </Box>
            <Typography variant="body2" style={{ marginTop: '12px' }}>
                {t(`QBRFirst.definitions.${reportType}`)}
            </Typography>
            <hr />
        </Box>
    );
};
